import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSnapcraftComponent } from './simple-icons-snapcraft.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSnapcraftComponent ],
    exports:      [ SimpleIconsSnapcraftComponent ],
    bootstrap:    []
})
export class SimpleIconsSnapcraftModule {}
